"use client";

import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M19.5 6c-1.31 0-2.37 1.01-2.48 2.3-1.88-.5-2.84-1.8-5.02-1.8-2.19 0-3.14 1.3-5.02 1.8C6.87 7.02 5.81 6 4.5 6 3.12 6 2 7.12 2 8.5V9c0 6 3.6 7.81 6.52 7.98C9.53 17.62 10.72 18 12 18s2.47-.38 3.48-1.02C18.4 16.81 22 15 22 9v-.5C22 7.12 20.88 6 19.5 6m-16 3v-.5c0-.55.45-1 1-1s1 .45 1 1v3c0 1.28.38 2.47 1.01 3.48C4.99 14.27 3.5 12.65 3.5 9m10.8 2.01c-.4-.17-.72-.36-1.01-.53-.46-.28-.8-.48-1.29-.48s-.84.2-1.31.48c-.28.17-.6.35-.98.51-.34.15-.71-.08-.71-.45 0-.2.11-.38.29-.45.34-.14.62-.31.88-.46C10.72 9.3 11.23 9 12 9s1.27.3 1.8.62c.27.16.55.33.9.48.18.08.29.26.29.45.01.36-.36.6-.69.46M20.5 9c0 3.65-1.49 5.27-3.01 5.98.64-1.01 1.01-2.2 1.01-3.48v-3c0-.55.45-1 1-1s1 .45 1 1z"
}), 'MasksRounded');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/icons-material/esm/MasksRounded.js
// module id = 7967
// module chunks = 0